import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import posthog from "posthog-js";
import React, { useState } from "react";

import RightForMeProps from "../types/RightForMe";

const RightForMe = ({ treatmentName, accordionData }: RightForMeProps) => {
    const [openSection, setOpenSection] = useState<number | null>(0);

    const toggleSection = (index: number) => {
        posthog?.capture("treatment_right_for_me_section_toggled", {
            treatmentName,
            sectionTitle: accordionData[index].title,
            sectionOpen: openSection === index,
        });
        setOpenSection(openSection === index ? null : index);
    };

    return (
        <div className="rounded-2xl">
            <h2 className="text-3xl md:text-5xl font-semibold font-satoshi uppercase mb-12 leading-tight text-center">
                Is {treatmentName} right for me?
            </h2>

            <div className="flex flex-col gap-3">
                {accordionData.map((section, index) => (
                    <div key={index} className="border-b border-white">
                        <button
                            onClick={() => toggleSection(index)}
                            className="w-full flex justify-between items-center py-4 text-left"
                            aria-label="Toggle Section"
                        >
                            <h3 className="text-xl md:text-2xl font-medium font-satoshi">
                                {section.title}
                            </h3>
                            <div className="t">
                                {openSection === index ? (
                                    <ChevronUpIcon className="h-6 w-6" />
                                ) : (
                                    <ChevronDownIcon className="h-6 w-6" />
                                )}
                            </div>
                        </button>

                        {openSection === index && (
                            <div className="text-lg font-normal font-space leading-relaxed pb-8">
                                {section.content}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RightForMe;
